import React, { useEffect, useState } from 'react';
import Modal from 'react-bootstrap/Modal';
import { useSelector } from 'react-redux';
import DropDownComp from './DropDownComp';
import InputComp from './InputComp';

const TruckModalComp = (props) => {

    const [truckType, setTruckType] = useState(props.rowDataUser && props.rowDataUser?.type ? { value: props.rowDataUser?.type?.toUpperCase(), label: props.rowDataUser?.type } : '')
    const [truckNo, setTruckNumber] = useState(props.rowDataUser && props.rowDataUser.bt_id ? props.rowDataUser.bt_id : '')
    const [divisionsArray, setDivisionArray] = useState([]);
    let divisionsArrayTemp = useSelector((state) => state.division.getDivisionData);
    divisionsArrayTemp = divisionsArrayTemp.filter((data,i)=>{
        return data?.is_active === true
     })
    const divisionSelectedTemp = useSelector((state) => state.division.divisionSelected);
    const [userDivisionName, setUserDivisionName] = useState('')

    const truckTypeArray = [{
        label: 'Switcher',
        value: 'SWITCHER'
    }, {
        label: 'Shuttle',
        value: 'SHUTTLE'
    }]

    useEffect(() => {
        if (divisionsArrayTemp) {
            var data = [];
            if (divisionSelectedTemp && divisionSelectedTemp != null && divisionSelectedTemp != '') {
                for (var i = 0; i < divisionsArrayTemp.length; i++) {
                    if (divisionsArrayTemp[i]?.division_id == divisionSelectedTemp.value) {
                        data.push({
                            label: divisionsArrayTemp[i].divisionName, value: divisionsArrayTemp[i].division_id, isdisabled: false
                        });
                    }
                    else {
                        data.push({
                            label: divisionsArrayTemp[i].divisionName, value: divisionsArrayTemp[i].division_id, isdisabled: true
                        });
                    }
                }
                setDivisionArray(data);
                setUserDivisionName(divisionSelectedTemp)
            }
            else {
                for (var i = 0; i < divisionsArrayTemp.length; i++) {
                    data.push({
                        label: divisionsArrayTemp[i].divisionName, value: divisionsArrayTemp[i].division_id
                    });
                }
                setDivisionArray(data);
            }
        }
        else {
            setUserDivisionName(divisionSelectedTemp)
        }
    }, [])

    return (
        <Modal
            size='lg'
            show={props.isShow}
            onHide={props.handleClose}
            backdrop="static"
            centered
            keyboard={false}
        >
            <Modal.Header style={{ backgroundColor: 'rgb(0, 42, 74)' }}>
                <Modal.Title style={{ fontFamily: 'Roboto', color: 'white' }}>
                    {props.title ? props.title : 'Add Truck'}
                </Modal.Title>
            </Modal.Header>

            <Modal.Body>

                <div className='row container' style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'space-between' }}>

                    <div className="row container mt-4 d-flex f-direction-row ">

                        <div className="col-12 col-lg-4 col-md-4 col-sm-12">
                            <label style={{ fontSize: 16 }}>{'Truck No'}</label>
                        </div>

                        <div className="col-12 col-lg-6 col-md-6 col-sm-12">
                            <InputComp
                                style={{
                                    display: 'flex',
                                    flexDirection: 'row',
                                    borderColor: 'hsl(0, 0%, 50%)',
                                    borderStyle: 'solid',
                                    borderWidth: '1px',
                                    padding: '4px',
                                    fontSize: 14,
                                    width: '100%'
                                }}
                                labelName={'Truck No'}
                                maxLength={30}
                                placeholder={'Truck No'}
                                value={truckNo}
                                isDisabled={props.rowDataUser?.bt_id != null ? true : false}
                                onChangeHandler={(truckNo) => {
                                    setTruckNumber(truckNo);
                                }}
                            />
                        </div>
                    </div>

                    <div className="row container mt-4 d-flex f-direction-row ">
                        <div className="col-12 col-lg-4 col-md-4 col-sm-12">
                            <div>
                                <label style={{ fontSize: 14 }}>Truck Type</label>
                            </div>
                        </div>
                        <div className="col-12 col-lg-6 col-md-6 col-sm-12">
                            <div>
                                <DropDownComp
                                    style={{
                                        height: 35,
                                        display: 'flex',
                                        flexDirection: 'row',
                                        borderColor: 'hsl(0, 0%, 50%)',
                                        borderStyle: 'solid',
                                        borderWidth: '1px',
                                        fontSize: 14
                                    }}
                                    name={'Select Truck Type'}
                                    options={truckTypeArray}
                                    onChange={(value) => {
                                        setTruckType(value);
                                    }}
                                    value={truckType}
                                />
                            </div>
                        </div>
                    </div>

                    <div className="row container mt-4 d-flex f-direction-row ">
                        <div className="col-12 col-lg-4 col-md-4 col-sm-12">
                            <label style={{ fontSize: 16, marginRight: 12 }}>{'Division Name'}</label>
                        </div>
                        <div className="col-12 col-lg-6 col-md-6 col-sm-12">
                            <DropDownComp
                                styles={{
                                    display: 'flex',
                                    flexDirection: 'row',
                                    alignSelf: 'center',
                                    alignItems: 'center',
                                    justifyContent: 'center',
                                    height: 35,
                                    borderColor: 'hsl(0, 0%, 50%)',
                                    borderStyle: 'solid',
                                    borderWidth: '1px'
                                }}
                                name={'Select Division Name'}
                                options={divisionsArray}
                                onChange={(value) => {
                                    setUserDivisionName(value);
                                }}
                                value={userDivisionName}

                            />
                        </div>
                    </div>
                </div>

            </Modal.Body >

            <Modal.Footer>
                <div className="row col-12 col-sm-12 col-md-12 col-lg-12" style={{ display: 'flex', justifyContent: 'space-around' }} >

                    <div className="col-12 col-sm-12 col-md-12 col-lg-6" >

                        <button onClick={() => {

                            let truckObj;
                            if (truckNo == '') {
                                alert('Please Enter Truck No');
                            }
                            if (truckType == '') {
                                alert('Please Select Truck Type');
                            }
                            else {
                                if (props.rowDataUser != null && props.rowDataUser != '') {
                                    truckObj = {
                                        "truck_id": props.rowDataUser?.truck_id || '',
                                        "bt_id": props.rowDataUser?.bt_id || '',
                                        "type": truckType?.value || '',
                                        "division_id": divisionSelectedTemp?.value || '',
                                        "is_active": true
                                    }
                                }
                                else {
                                    truckObj = {
                                        "bt_id": truckNo || '',
                                        "type": truckType?.value || '',
                                        "division_id": divisionSelectedTemp?.value || '',
                                        "is_active": true
                                    }
                                }
                            }
                            props.setValue(truckObj);
                        }}
                            style={{ backgroundColor: '#002a4a', height: '80%', color: 'white', width: '100%', borderRadius: 8, borderWidth: 1 }}
                            className='btn btn-primary' variant="primary">
                            {props.rowDataUser != null ? 'Edit Truck' : 'Add Truck'}
                        </button>
                    </div>

                    <div className="col-12 col-sm-12 col-md-12 col-lg-6" >
                        <button
                            style={{ backgroundColor: '#002a4a', height: '80%', color: 'white', width: '100%', borderRadius: 8, borderWidth: 1 }}

                            onClick={() => {
                                props.show(false)
                            }} className='btn btn-primary' variant="primary">
                            {'Cancel'}
                        </button>
                    </div>
                </div>
            </Modal.Footer>
        </Modal >
    );
}
export default TruckModalComp;